.screen {
  padding: 30px 56px;
  display: grid;
  grid-template-columns: 290px 1fr 290px;
  gap: 36px;
  animation: evx-fadeUp 0.4s ease both;
}

.details {
  align-self: center;
  margin: 0;
  padding: 24px 26px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.fields {
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.details dt {
  margin-bottom: 4px;
}
.details dd {
  margin: 0;
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 20px;
  color: var(--color-text);
}
.details .safeBadge {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  padding: 8px 14px;
  background: var(--color-success-100);
  color: var(--color-success-700);
  border-radius: var(--radius-sm);
  font-size: 18px;
}
.safeDot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--color-success);
  animation: evx-pulse 1.6s infinite;
}

.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
}
.danger {
  padding: 14px 32px;
  background: var(--color-danger-100);
  color: var(--color-danger);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 26px;
  line-height: 1.55;
  text-align: center;
  animation: evx-blink 1.4s infinite;
}
.ringContent {
  gap: 4px;
}
.time {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 104px;
  line-height: 1;
  font-variant-numeric: tabular-nums;
  color: var(--color-text);
}
.percent {
  font-family: var(--font-heading);
  font-size: 17px;
  font-weight: 700;
  color: var(--color-danger-700);
}

.controls {
  align-self: center;
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.estop {
  height: 170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: var(--color-danger);
  border: none;
  border-radius: var(--radius-lg);
  cursor: pointer;
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 24px;
  color: #ffffff;
  box-shadow: var(--shadow-lg);
}
.estop:hover,
.estop:active {
  background: var(--color-danger-700);
}
.estopHint {
  font-size: 11px;
  color: var(--color-neutral-600);
  font-weight: 600;
  text-align: center;
}
.demoBreach {
  padding: 14px;
  background: var(--color-neutral-100);
  border: none;
  border-radius: var(--radius-md);
  font-size: 11px;
  font-weight: 700;
  color: var(--color-neutral-700);
  cursor: pointer;
}
.demoBreach:hover {
  background: var(--color-accent-100);
  color: var(--color-accent-700);
}
